/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';

/*Import Requisição API*/
import api from '../../../../api';
import { formatadorCPF, formatarCpfCnpj, validadorCNPJ, validadorCPF, validadorEmail } from '../../../../utils/Validadores';

export default function CadastroFornecedor() {
    /* Variáveis auxiliares para dados */
    const navigate = useNavigate();
    const location = useLocation();
    const id_fornecedor = location.state?.id;
    const [produtos, setProdutos] = useState([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState([]);
    const [busca, setBusca] = useState('');
    const [filtroEstoque, setFiltroEstoque] = useState('');
    const [pesquisa, setPesquisa] = useState('');
    const [errors, setErrors] = useState(null);

    /* ID's */
    const [idFornecedor, setIdFornecedor] = useState("");
    const [usuario_id, setIdUsuario] = useState('');
    const [idFornecedorParaExcluir, setIdFornecedorParaExcluir] = useState(null);

    /* Variáveis de Dados do Fornecedor */
    const [nome, setNome] = useState('');
    const [cpf_cnpj, setCpfCnpj] = useState('');
    const [telefone, setTelefone] = useState('');
    const [email, setEmail] = useState('');
    const [site, setSite] = useState('');
    const [contatoNome, setContatoNome] = useState('');
    const [contatoEmail, setContatoEmail] = useState('');
    const [razaoSocial, setRazaoSocial] = useState('');
    const [inscricaoEstadual, setInscricaoEstadual] = useState('');
    const [inscricaoMunicipal, setInscricaoMunicipal] = useState('');
    const [statusFornecedor, setStatusFornecedor] = useState('Ativo');

    /* Variáveis de Dados de Endereço do Fornecedor */
    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');
    const [userLocation, setUserLocation] = useState(null);
    const [destination, setDestination] = useState(null);

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    const buscarEnderecoPorCep = async (cep) => {
        if (cep.length !== 8) {
            setTexto('Por favor, insira um CEP válido com 8 dígitos.');
            abrirModalAviso();
            return;
        }
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const data = await response.json();
            if (data.erro) {
                setTexto('CEP não encontrado.');
                abrirModalAviso();
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
            }
        } catch (error) {
            console.error('Erro ao buscar endereço:', error);
            setTexto('Erro ao buscar o endereço. Tente novamente mais tarde.');
            abrirModalAviso();
        }
    };

    const mascaraCep = (valor) => {
        return valor
            .replace(/\D/g, '')
            .replace(/(\d{5})(\d{3})/, '$1-$2')
            .slice(0, 9);
    };

    const handleNumericInput = (e) => {
        const charCode = e.which || e.keyCode;
        if (charCode < 48 || charCode > 57) {
            e.preventDefault();
        }
    };

    const handleCpfCnpjChange = (e) => {
        const value = e.target.value;
        const formattedValue = formatarCpfCnpj(value);
        setCpfCnpj(formattedValue);

        const rawValue = value.replace(/\D/g, '');
        if (rawValue.length === 11 && !validadorCPF(rawValue)) {
            setErrors((prev) => ({ ...prev, cpfCnpj: 'CPF inválido!' }));
        } else if (rawValue.length === 14 && !validadorCNPJ(rawValue)) {
            setErrors((prev) => ({ ...prev, cpfCnpj: 'CNPJ inválido!' }));
        } else {
            setErrors((prev) => ({ ...prev, cpfCnpj: '' }));
        }
    };

    const handleTelefoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        let formattedValue;

        if (value.length <= 10) {
            formattedValue = value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
        } else {
            formattedValue = value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
        }
        setTelefone(formattedValue);

        if (value.length < 10 || value.length > 11) {
            setErrors((prev) => ({ ...prev, telefone: 'Telefone inválido!' }));
        } else {
            setErrors((prev) => ({ ...prev, telefone: '' }));
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        if (value && !validadorEmail(value)) {
            setErrors((prev) => ({ ...prev, email: 'Email inválido!' }));
        } else {
            setErrors((prev) => ({ ...prev, email: '' }));
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                console.log("Resposta da API:", response.data);

                if (response.data.success) {
                    console.log('Passei aqui');
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    // Funções auxiliares (exemplos—ajuste as regexes conforme sua necessidade)
    const validadorEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const validadorURL = (url) => {
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    };

    const validarDados = () => {
        // Campos obrigatórios
        if (!nome.trim()) return 'O nome é obrigatório.';
        if (!cpf_cnpj.trim()) return 'O CPF ou CNPJ é obrigatório.';

        // CPF/CNPJ
        const digitosCpfCnpj = cpf_cnpj.replace(/\D/g, '');
        if (digitosCpfCnpj.length <= 11) {
            if (!validadorCPF(digitosCpfCnpj)) return 'CPF inválido.';
        } else {
            if (!validadorCNPJ(digitosCpfCnpj)) return 'CNPJ inválido.';
        }

        // Telefone
        const digitosTel = telefone.replace(/\D/g, '');
        if (digitosTel.length < 10 || digitosTel.length > 11)
            return 'O telefone deve ter entre 10 e 11 dígitos.';

        // E-mail principal
        if (!email.trim()) return 'O e-mail é obrigatório.';
        if (!validadorEmail(email)) return 'E-mail inválido.';

        // Site (opcional, mas se preenchido deve ser URL válida)
        if (site.trim() && !validadorURL(site))
            return 'URL do site inválida.';

        // Contato (opcional, mas se e-mail preenchido, nome também)
        if (contatoEmail.trim() && !validadorEmail(contatoEmail))
            return 'E-mail de contato inválido.';
        if (contatoEmail.trim() && !contatoNome.trim())
            return 'Informe o nome do contato quando preencher o e-mail.';

        // Endereço
        if (!cep.trim()) return 'O CEP é obrigatório.';
        if (!logradouro.trim()) return 'O logradouro é obrigatório.';
        if (!numero.trim()) return 'O número é obrigatório.';
        if (!bairro.trim()) return 'O bairro é obrigatório.';
        if (!cidade.trim()) return 'A cidade é obrigatória.';
        if (!estado.trim()) return 'O estado é obrigatório.';

        // Tudo OK
        return null;
    };

    const enviarCadastroFornecedor = async (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // 1) validação local
        const erroValidacao = validarDados();
        if (erroValidacao) {
            setTexto(erroValidacao);
            abrirModalAviso();
            return;
        }

        // 2) limpeza de dados
        const telefoneLimpo = telefone.replace(/\D/g, '');
        const cpfCnpjLimpo = cpf_cnpj.replace(/\D/g, '');

        // 3) verifica existência de CPF/CNPJ
        try {
            const { data: v } = await api.post('/fornecedores/verificar', { cpf_cnpj: cpfCnpjLimpo });
            if (v.exists) {
                setTexto('Este CPF/CNPJ já está cadastrado.');
                abrirModalAviso();
                return;
            }
        } catch (err) {
            console.error('Erro ao verificar CPF/CNPJ:', err);
            setTexto('Erro ao verificar CPF/CNPJ. Tente novamente mais tarde.');
            abrirModalAviso();
            return;
        }

        // 4) monta payload
        setLoading(true);
        const fornecedor = {
            nome: nome.trim(),
            cpf_cnpj: cpfCnpjLimpo,
            telefone: telefoneLimpo,
            email: email.trim(),
            site: site.trim() || null,
            contato_nome: contatoNome.trim() || null,
            contato_email: contatoEmail.trim() || null,
            razao_social: razaoSocial.trim() || null,
            inscricao_estadual: inscricaoEstadual.trim() || null,
            inscricao_municipal: inscricaoMunicipal.trim() || null,
            status_fornecedor: statusFornecedor,
        };
        const endereco = {
            cep: cep.trim(),
            logradouro: logradouro.trim(),
            numero: numero.trim(),
            complemento: complemento.trim() || null,
            bairro: bairro.trim(),
            cidade: cidade.trim(),
            estado: estado.trim(),
            tipo: 'Comercial',
        };

        try {
            await api.post('/fornecedores', { fornecedor, endereco, usuario_id });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            navigate('/menu/fornecedores');
        } catch (err) {
            console.error('Erro ao enviar os dados:', err);
            setTexto('Ocorreu um erro ao tentar cadastrar o fornecedor. Tente novamente mais tarde.');
            abrirModalAviso();
        } finally {
            setLoading(false);
        }
    };

    const preencherCampos = () => {
        setNome('Fornecedor Exemplo');
        setCpfCnpj('12345678000195');
        setTelefone('11999999999');
        setEmail('fornecedor@exemplo.com');
        setSite('www.exemplo.com');
        setContatoNome('João Silva');
        setContatoEmail('contato@exemplo.com');

        setCep('12345678');
        setLogradouro('Rua Exemplo');
        setNumero('123');
        setComplemento('Apto 45');
        setBairro('Bairro Exemplo');
        setCidade('São Paulo');
        setEstado('SP');
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'e') {
                e.preventDefault();
                preencherCampos();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const handleCpfOuCnpjChange = (e) => {
        const { value } = e.target;
        const sanitizedValue = value.replace(/\D/g, '');

        let valorFormatado = sanitizedValue;

        if (sanitizedValue.length <= 11) {
            valorFormatado = formatadorCPF(sanitizedValue);
        } else if (sanitizedValue.length <= 14) {
            valorFormatado = formatarCpfCnpj(sanitizedValue);
        }

        setCpfCnpj(valorFormatado);
    };

    return (
        <section className='container-principal-cadastro-fornecedor'>
            <dialog id="CaixaDeDialogoAviso" className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button id="botao" onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>
            <Cabecalho />

            <CookieAceite />

            <main>

                <MenuLateral />

                <section className='conteudo-cadastro-fornecedor'>

                    <div className='titulo-perfil'>
                        <h1><span>Fornecedores</span> &gt; Cadastro de Fornecedor</h1>
                    </div>

                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Salvando...</h2>
                        </div>
                    ) : (
                    <div className='perfil-cadastro-fornecedor'>
                        <h2>Digite os dados do Fornecedor</h2>
                        <form className='form-cadastro-fornecedor' onSubmit={enviarCadastroFornecedor}>

                            <label className='lasbel-nome'>Nome: <span className='span-obrigatorio'>*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o nome do fornecedor"
                                />
                            </div>

                            <label className="label-cnpj">
                                CPF ou CNPJ: <span className="span-obrigatorio">*</span>
                            </label>
                            <div className="input-cnpj">
                                <input
                                    type="text"
                                    value={cpf_cnpj}
                                    onChange={handleCpfOuCnpjChange}
                                    placeholder="Digite o CPF ou CNPJ"
                                />
                            </div>

                            <label className="label-telefone">
                                Telefone: <span className="span-obrigatorio">*</span>
                            </label>
                            <div className="input-telefone">
                                <input
                                    type="text"
                                    value={telefone}
                                    onChange={handleTelefoneChange}
                                    onKeyPress={handleNumericInput}
                                    placeholder="Digite o telefone"
                                />
                            </div>

                            <label className="label-email">
                                Email: <span className="span-obrigatorio">*</span>
                            </label>
                            <div className="input-email">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    placeholder="Digite seu email"
                                />
                            </div>

                            <label className='lasbel-site'>Site:</label>
                            <div className="input-site">
                                <input
                                    type="text"
                                    value={site}
                                    onChange={(e) => setSite(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o site (Opcional)"
                                />
                            </div>
                            <label className='lasbel-nomeContato'>Nome para Contato:</label>
                            <div className="input-nomeContato">
                                <input
                                    type="text"
                                    value={contatoNome}
                                    onChange={(e) => setContatoNome(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o para Contato (Opcional)"
                                />
                            </div>
                            <label className='lasbel-emailContato'>Nome para contato email:</label>
                            <div className="input-emailContato">
                                <input
                                    type="text"
                                    value={contatoEmail}
                                    onChange={(e) => setContatoEmail(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o e-mail para contato (Opcional)"
                                />
                            </div>

                            <label className='lasbel-razaoSocial'>Razão Social:</label>
                            <div className="input-razaoSocial">
                                <input
                                    type="text"
                                    value={razaoSocial}
                                    onChange={(e) => setRazaoSocial(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite a razão social (Opcional)"
                                />
                            </div>

                            <label className='lasbel-inscricaoEstadual'>Inscrição Estadual (IE):</label>
                            <div className="input-inscricaoEstadual">
                                <input
                                    type="text"
                                    value={inscricaoEstadual}
                                    onChange={(e) => setInscricaoEstadual(e.target.value)}
                                    maxLength={20}
                                    placeholder="Digite a inscrição estadual (Opcional)"
                                />
                            </div>

                            <label className='lasbel-inscricaoMunicipal'>Inscrição Municipal (IM):</label>
                            <div className="input-inscricaoMunicipal">
                                <input
                                    type="text"
                                    value={inscricaoMunicipal}
                                    onChange={(e) => setInscricaoMunicipal(e.target.value)}
                                    maxLength={20}
                                    placeholder="Digite a inscrição municipal (Opcional)"
                                />
                            </div>

                            <label>Status do Fornecedor:</label>
                            <div className="input-statusFornecedor">
                                <select value={statusFornecedor} onChange={(e) => setStatusFornecedor(e.target.value)}>
                                    <option value="Ativo">Ativo</option>
                                    <option value="Inativo">Inativo</option>
                                    <option value="Bloqueado">Bloqueado</option>
                                </select>
                            </div>

                            <div className='linha-1-endereco'>
                                <div className='conteudo-cep'>
                                    <label className='lasbel-cep'>CEP: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-cep'>
                                        <input
                                            type="text"
                                            value={cep}
                                            onChange={(e) => setCep(mascaraCep(e.target.value))}
                                            onBlur={() => buscarEnderecoPorCep(cep.replace(/\D/g, ''))}
                                            maxLength={8}
                                            placeholder="Digite o CEP"
                                        />
                                    </div>
                                </div>

                                <div className='conteudo-numero'>
                                    <label className='lasbel-numero'>Número: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-numero'>
                                        <input
                                            type="text"
                                            value={numero}
                                            onChange={(e) => setNumero(e.target.value)}
                                            placeholder="Digite o Nº"
                                        />
                                    </div>
                                </div>
                            </div>

                            <label>Logradouro:</label>
                            <div className='input-logradouro'>
                                <input
                                    type="text"
                                    value={logradouro}
                                    onChange={(e) => setLogradouro(e.target.value)}
                                    placeholder="Logradouro"
                                    disabled
                                />
                            </div>

                            <label>Bairro:</label>
                            <div className='input-bairro'>
                                <input
                                    type="text"
                                    value={bairro}
                                    onChange={(e) => setBairro(e.target.value)}
                                    placeholder="Bairro"
                                    disabled
                                />
                            </div>

                            <div className='linha-5-endereco'>
                                <div className='conteudo-cidade'>
                                    <label className='lasbel-cidade'>Cidade:</label>
                                    <div className='input-cidade'>
                                        <input
                                            type="text"
                                            value={cidade}
                                            onChange={(e) => setCidade(e.target.value)}
                                            placeholder="Cidade"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className='conteudo-estado'>
                                    <label className='label-estado'>Estado:</label>
                                    <div className='input-estado'>
                                        <input
                                            type="text"
                                            value={estado}
                                            onChange={(e) => setEstado(e.target.value)}
                                            maxLength={2}
                                            placeholder="Estado"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <label>Complemento:</label>
                            <div className='input-complemento'>
                                <input
                                    type="text"
                                    value={complemento}
                                    onChange={(e) => setComplemento(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o complemento (Opcional)"
                                />
                            </div>

                            <button className='bnt-cadastro-fornecedor' type="submit">Cadastrar Fornecedor</button>
                        </form>
                    </div>
                    )}

                </section>
            </main >

            <Rodape />

        </section >
    );
}
